var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.121,
    height: 5.121,
    viewBox: "0 0 8.121 5.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drop_down",
    "data-name": "drop down",
    transform: "translate(-2713.544 -108.439)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    x2: 3,
    y2: 3,
    transform: "translate(2714.604 109.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_182",
    "data-name": "Line 182",
    x1: 3,
    y2: 3,
    transform: "translate(2717.604 109.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/drop down.5a06b6a24f0660a0030411cd7acae811.svg";
export { ForwardRef as ReactComponent };